// action - account reducer
export const LOGIN = '@auth/LOGIN';
export const LOGOUT = '@auth/LOGOUT';
export const REGISTER = '@auth/REGISTER';
export const GET_ALL_RESIDENTS = '@residents/GET_ALL_RESIDENTS';
export const GET_ALL_CONSULTANTS = '@consultants/GET_ALL_CONSULTANTS';
export const GET_ALL_PATIENTS = '@patients/GET_ALL_PATIENTS';
export const CURRENT_PATIENT = '@patients/CURRENT_PATIENT';